import { useState } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { Leaf, Lock } from 'lucide-react'
import toast from 'react-hot-toast'
import api from '../../services/api'

export default function ResetPasswordPage() {
    const { token } = useParams()
    const navigate = useNavigate()
    const [password, setPassword] = useState('')
    const [confirm, setConfirm] = useState('')
    const [loading, setLoading] = useState(false)

    const onSubmit = async (e) => {
        e.preventDefault()
        if (password !== confirm) return toast.error("Les mots de passe ne correspondent pas.")
        if (password.length < 6) return toast.error("Le mot de passe doit faire au moins 6 caractères.")

        setLoading(true)
        try {
            await api.post('/api/auth/reset-password', { 
                token: token,
                new_password: password 
            })
            toast.success("Mot de passe mis à jour !")
            navigate('/admin/login')
        } catch (error) {
            toast.error(error.response?.data?.detail || "Ce lien est invalide ou a expiré.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-sage-50">
            <div className="card max-w-md w-full relative z-10 shadow-xl bg-white p-8">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Lock className="w-8 h-8 text-sage-600" />
                    </div>
                    <h1 className="text-2xl font-serif text-sage-800">Nouveau mot de passe</h1>
                </div>

                <form onSubmit={onSubmit} className="space-y-4">
                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Nouveau mot de passe</label>
                        <input 
                            type="password" required autoFocus minLength="6"
                            value={password} onChange={e => setPassword(e.target.value)} 
                            className="w-full py-3 bg-gray-50 focus:bg-white" 
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Confirmer le mot de passe</label>
                        <input 
                            type="password" required minLength="6"
                            value={confirm} onChange={e => setConfirm(e.target.value)} 
                            className="w-full py-3 bg-gray-50 focus:bg-white" 
                        />
                    </div>

                    <button type="submit" disabled={loading || !password || !confirm} className="w-full btn btn-primary py-3 flex items-center justify-center mt-2">
                        {loading ? <div className="spinner w-5 h-5 border-white"/> : "Valider mon mot de passe"}
                    </button>
                    
                    <div className="text-center mt-4">
                        <Link to="/admin/login" className="text-xs text-gray-400 hover:text-gray-600">Retour à la connexion</Link>
                    </div>
                </form>
            </div>
        </div>
    )
}